export default __webpack_public_path__ + "eaf479f6db7bf6e7e31db439ed0a8384.png";